import { ArrowBack, ArrowForward } from '@mui/icons-material';
import {
  Box,
  Button,
  CircularProgress,
  Container,
  FormControlLabel,
  IconButton,
  List,
  Paper,
  Stack,
  Switch,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import NotificationItem from '../../components/notifications/NotificationItem';
import NewLayout from '../../layout/dashboard/NewLayout';
import { getUserNotifications, markAllRead } from '../../modules/notification';

const NotificationsPage = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalNotifications, setTotalNotifications] = useState(0);
  const [filterUnread, setFilterUnread] = useState(false);

  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const data = await getUserNotifications(page, 10, filterUnread);
      setNotifications(data.notifications);
      setTotalNotifications(data.total_notifications);
    } catch (error) {
      console.error('Error fetching notifications', error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleFilterChange = (event) => {
    setFilterUnread(event.target.checked);
  };

  const handleMarkAllRead = async () => {
    try {
      await markAllRead();
      fetchNotifications();
    } catch (error) {
      console.error('Error marking all as read', error);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, [page, filterUnread]);

  return (
    <NewLayout>
      <Container maxWidth="xl">
        <Box sx={{ padding: 3 }}>
          <Typography variant="h4" sx={{ marginBottom: 3, fontWeight: 600 }}>
            Notifications
          </Typography>
          <Stack
            direction="row"
            spacing={2}
            sx={{
              marginBottom: 2,
            }}>
            <FormControlLabel
              control={
                <Switch
                  checked={filterUnread}
                  onChange={handleFilterChange}
                  name="filterUnread"
                  color="primary"
                />
              }
              label="Show Unread Notifications"
              sx={{
                '& .MuiFormControlLabel-label': {
                  fontSize: '14px',
                },
              }}
            />

            <Button
              variant="text"
              color="primary"
              onClick={handleMarkAllRead}
              disabled={loading || notifications.length === 0}>
              Mark All as Read
            </Button>
          </Stack>
          <Paper sx={{ padding: 2 }}>
            {loading ? (
              <Box
                sx={{ display: 'flex', justifyContent: 'center', padding: 2 }}>
                <CircularProgress size={40} />
              </Box>
            ) : notifications.length === 0 ? (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ textAlign: 'center' }}>
                You have no new notifications.
              </Typography>
            ) : (
              <List>
                {notifications.map((notification) => (
                  <NotificationItem
                    key={notification.id}
                    notification={notification}
                    fetchNotifications={fetchNotifications}
                  />
                ))}
              </List>
            )}
          </Paper>

          {totalNotifications > 10 && (
            <Box
              sx={{ display: 'flex', justifyContent: 'center', marginTop: 3 }}>
              <Stack direction="row" spacing={2} alignItems="center">
                {page > 1 && (
                  <IconButton
                    onClick={() => handlePageChange(page - 1)}
                    color="primary"
                    sx={{ borderRadius: '50%' }}>
                    <ArrowBack />
                  </IconButton>
                )}
                <Typography variant="body2" color="text.secondary">
                  Page {page}
                </Typography>
                {page * 10 < totalNotifications && (
                  <IconButton
                    onClick={() => handlePageChange(page + 1)}
                    color="primary"
                    sx={{ borderRadius: '50%' }}>
                    <ArrowForward />
                  </IconButton>
                )}
              </Stack>
            </Box>
          )}
        </Box>
      </Container>
    </NewLayout>
  );
};

export default NotificationsPage;
